<template>
  <div :class="$style.animation">
    <div :class="$style.animationTop">
      <svg
        width="56"
        height="31"
        viewBox="0 0 56 31"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="[$style.animationTopIcon]"
      >
        <g :class="[$style.animationTopIconShadow]">
          <path
            d="M38.799 19.6833C44.828 19.0313 51.427 16.199 51.427 16.199L55.208 17.1023C55.471 17.156 55.64 17.0073 55.417 16.8787L52.566 15.2329C52.93 14.5084 52.649 12.8704 50.333 11.5332C48.952 10.736 47.453 10.2642 45.745 10.016C45.745 10.016 43.206 9.68179 39.144 9.40339L26.869 8.46669C25.909 8.40419 24.985 8.16599 24.094 7.65169L15.363 2.61149C15.096 2.45719 15.015 2.60699 14.931 2.70649C13.808 4.07509 13.922 5.91219 16.773 7.55799L12.806 7.48199C12.677 7.50549 12.506 7.60389 12.684 7.70679L20.48 12.207C26.092 15.4471 31.825 16.1491 37.207 15.6649C37.641 15.6201 38.118 15.5508 38.551 15.5061C38.598 15.5821 38.513 15.6313 38.383 15.6548C36.526 16.0585 32.501 16.7361 28.339 16.1045C26.979 15.8608 26.497 15.7792 24.824 15.3051C24.692 15.2783 24.562 15.3018 24.521 15.3767L19.588 21.8763L21.37 22.905L25.933 16.9789C27.804 18.0589 32.772 20.3856 38.799 19.6833ZM47.327 12.6513C48.418 12.6905 49.308 13.2048 49.332 13.8085C49.399 14.438 48.59 14.9054 47.499 14.8663C46.409 14.8272 45.518 14.3129 45.495 13.7091C45.385 13.1042 46.237 12.6122 47.327 12.6513Z"
            fill="white"
          />
          <path d="M10.6911 7.98329C7.5421 8.77269 4.0911 9.63379 0.298096 10.6916L8.09409 15.1918L18.2641 12.3549L10.6911 7.98329Z" fill="white" />
          <path d="M26.9171 18.777L23.0601 23.832L24.8421 24.8606L28.8631 19.5562C28.2901 19.3729 27.6261 19.0878 26.9171 18.777Z" fill="white" />
          <path d="M27.048 7.43809L33.95 7.97909C36.797 7.26119 39.819 6.54559 42.457 6.05129C41.965 6.84969 41.473 7.64799 40.895 8.49549C44.697 8.82079 46.969 9.00079 49.22 9.75879C50.279 7.86139 51.056 6.53859 51.337 5.91359L42.651 0.899094C40.487 1.27369 32.399 2.75429 21.989 5.00969L25.151 6.83549C25.686 7.14409 26.306 7.40349 27.048 7.43809Z" fill="white" />
          <path d="M30.8892 20.1352L26.5352 25.8376L34.2411 30.2864C36.9841 26.8515 39.3822 23.5128 41.5282 20.4223C37.6782 21.1022 35.1082 21.0944 30.8892 20.1352Z" fill="white" />
        </g>
      </svg>
      <div :class="[$style.animationTopDisc]" />
    </div>
    <div :class="[$style.animationBase, $style.animationTransformMatrix]" />
  </div>
</template>

<script>
  export default {
    name: 'AwCsrAnimation',
  };

</script>

<style module lang="scss" rel="stylesheet/scss">
.animation {
  position: relative;
  width: 126px;
  height: 108px;

  &TransformMatrix {
    transform: matrix(0.866044, 0.499967, -0.866044, 0.499967, 0, -7.28796);
  }

  &Top {
    &Disc {
      position: absolute;
      z-index: 1;
      bottom: 37px;
      left: 60px;
      width: 66px;
      height: 66px;
      transform: matrix(0.866044, 0.499967, -0.866044, 0.499967, 0, -7.28796);
      animation: slideInWithMatrix 3s ease-in-out;
      border-radius: 50%;
      background-color: $color-strawberry-500;
      @include desktop-small(min) {
        bottom: 50px;
        left: 44px;
        width: 91px;
        height: 91px;
      }
    }

    &Icon {
      position: absolute;
      z-index: 2;
      bottom: 62px;
      left: 66px;
      width: 45px;
      height: 45px;
      animation: slideIn 3s ease-in-out;
      @include desktop-small(min) {
        bottom: 80px;
        left: 57px;
        width: 60px;
        height: 60px;
      }

      &Shadow {
        filter: drop-shadow(0 11px 5px rgba($color-black, 0.4));
      }
    }
  }

  &Base {
    position: absolute;
    z-index: 0;
    bottom: 0;
    left: 50px;
    width: 88px;
    height: 88px;
    animation: grow 3s ease-in-out;
    border: 1px dashed rgba($color-strawberry-500, 0.32);
    border-radius: 50%;
    background-color: rgba($color-strawberry-500, 0.17);
    box-shadow: inset 0 0 7px 10px white;
    @include desktop-small(min) {
      bottom: 0;
      left: 30px;
      width: 119px;
      height: 119px;
      background-color: rgba($color-strawberry-500, 0.08);
      box-shadow: inset 0 0 0 20px white;
    }
  }
}

@keyframes slideInWithMatrix {
  from {
    transform: translateY(-100%) matrix(0.866044, 0.499967, -0.866044, 0.499967, 0, -7.28796);
    opacity: 0;
  }

  25% {
    opacity: 0;
  }

  50% {
    opacity: 1;
  }

  75% {
    transform: translateY(2px) matrix(0.866044, 0.499967, -0.866044, 0.499967, 0, -7.28796);
    opacity: 1;
  }

  to {
    transform: translateY(0) matrix(0.866044, 0.499967, -0.866044, 0.499967, 0, -7.28796);
    opacity: 1;
  }
}

@keyframes slideIn {
  from {
    transform: translateY(-200%);
    opacity: 0;
  }

  25% {
    opacity: 0;
  }

  50% {
    opacity: 1;
  }

  75% {
    transform: translateY(2px);
    opacity: 1;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes grow {
  from {
    box-shadow: inset 0 0 0 30px white;
  }

  75% {
    box-shadow: inset 0 0 0 10px white;
  }

  to {
    box-shadow: inset 0 0 0 20px white;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  25% {
    opacity: 0;
  }

  75% {
    opacity: 0.5;
  }
}
</style>
